import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import logo from '../img/logo.svg'

function Footer() {

  const { t } = useTranslation();

  const { hostname } = document.location;

  return (
    <div className='z-10 relative bg-[#1A1A28]'>
      <div className='flex flex-col xl:flex-row container mx-auto pt-[160px]'>
        <img src={logo} alt="" className='w-[100px] h-[35px] xl:mx-[20px]'/>
        <div className='ml-[20px] xl:ml-[70px] gap-[15px] flex flex-col mt-[30px] xl:mt-0'>
          <p className='text-[#FFFFFFB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer1')} +41779206709</p>
          <div>
            <p className='text-[#FFFFFFB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer2')} Seestrasse 112, 8806 Bäch SZ, Freienbach</p>
          </div>
          <p className='text-[#FFFFFFB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer3')} support@{hostname}</p>
          <p className='text-[#FFFFFFB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer9')} <a className='text-[#2045FE]' href="https://www.zefix.ch/en/search/entity/list/firm/1213963">Zefix</a>.</p>
          <p className='text-[#FFFFFFB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>CH-130-4021672-9</p>
        </div>
        <div className='ml-[20px] xl:ml-[450px] gap-[15px] flex flex-col mt-[15px] xl:mt-0'>
          <a href="/docs/client.pdf"><p className='text-[#FFFFFFB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer4')}</p></a>
          <a href="/docs/conflict.pdf"><p className='text-[#FFFFFFB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer5')}</p></a>
          <a href="/docs/privacy.pdf"><p className='text-[#FFFFFFB2] ibm-plex text-[14px] xl:text-[16px] font-normal'>{t('footer6')}</p></a>
        </div>
      </div>
      <div className='flex flex-col container mx-auto pl-[20px] xl:pl-[205px] pt-[40px]'>
        <p className='text-[#FFFFFFB2] ibm-plex text-[12px] font-normal'>{t('footer7')}</p>
        <p className='text-[#FFFFFFB2] ibm-plex text-[12px] font-light mt-[6px] pr-[30px] xl:pr-0'><Trans>{t('footer8')}</Trans></p>
        <p className='flex justify-end pb-[150px] mt-[14px] ibm-plex text-[16px] text-[#FFFFFFB2] pr-[30px] xl:pr-0'>Fides Advisory © {new Date().getFullYear()}. All rights reserved.</p>      
      </div>
    </div>
  );
}

export default Footer;